import { combineReducers } from "redux";
import { adminReducer } from "./AdminReducer";
import { alert } from "./AlertReducer";
import { userReducer } from "./UserReducer";
import { rolesReducer } from "./RolesReducer";
import { permissionsReducer } from "./PermissionReducer";
import { frontEndUserReducer } from "./FrontEndReducer";
import { settingsReducer } from "./SettingsReducer";
import { ordersReducer } from "./OrderReducer";
import { moduleReducer } from "./ModuleReducer";
import { ShippingReducer } from "./ShippingReducer";
import { accountReducer } from "./AccountReducer";
import { itemReducer } from "./ItemReducer";
import { listReducer } from "./ListReducer";
import { listTypeReducer } from "./ListType";
import { brandReducer } from "./BrandReducer";
import { customerReducer } from "./CustomerReducer";
import { shippingOptionReducer } from "./ShippingOptionReducer";
import { addressReducer } from "./AddressReducer";
import { createOrdersReducer } from "./CreateOrderReducer";
import { dataSyncReducer } from "./DataSync";

const rootReducer = combineReducers({
    adminReducer,
    userReducer,
    frontEndUserReducer,
    rolesReducer,
    permissionsReducer,
    settingsReducer,
    ordersReducer,
    alert,
    moduleReducer,
    ShippingReducer,
    accountReducer,
    itemReducer,
    listTypeReducer,
    listReducer,
    brandReducer,
    customerReducer,
    shippingOptionReducer,
    addressReducer,
    createOrdersReducer,
    dataSyncReducer
});
export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.jsx